import React from 'react'
import Typography from '@material-ui/core/Typography'

const XTypography = ({ children, ...props }) => <Typography {...props}>{children}</Typography>

export default XTypography
